export default __webpack_public_path__ + "static/media/Monday_05.1bb48159.png";